import React, {useCallback, useEffect, useState} from 'react';
import {Suggest} from "uikit";
import {RegionSuggestSchema} from "@/views/Admin/Statistic/Member/RegionSuggest/RegionSuggest.schema";
import {RegionSuggestPropsInterface} from "@/views/Admin/Statistic/Member/RegionSuggest/RegionSuggest.props.interface";
import {RegionSuggestInterface} from "@/views/Admin/Statistic/Member/RegionSuggest/RegionSuggest.interface";
import {RegionType} from "@/views/Admin/Statistic/Member/EditField/EditField.interface";

const RegionSuggest = ({data, onChange}: RegionSuggestPropsInterface) => {
    const [fieldData, setFieldData] = useState<RegionSuggestInterface>({...RegionSuggestSchema})

    useEffect(() => {
        const initValue : RegionType = data.regionList && data.regionList.find(region => region.id === Number(data.fieldValue.data));
        setFieldData(prev =>({
                ...prev,
                initialValue: initValue ? initValue.name : null,
            })
        );
    }, [data.regionList, data.fieldValue.data]);


    const handleSelectField = (value) => {
        onChange(prev => ({...prev, fieldValue: {...prev.fieldValue, data: value}}))
    }

    const onChangeSuggest = (e) => {
        const selectedItem = data.regionList?.find(item => item.pos === Number(e));
        handleSelectField(selectedItem.id)
        onChange(prev =>({
            ...prev,
            editInput: {...prev.editInput, value: selectedItem.name, error: null}
        }))
    }

    const parseList = useCallback(() => {
        if (!data.regionList) return {};

        return Object.fromEntries(
            data.regionList
                .filter(({ name }) =>
                    !data.editInput.value || name.toLowerCase().includes(String(data.editInput.value)?.toLowerCase())
                )
                .sort((a, b) => a.pos - b.pos)
                .map(({ pos, name }) => [pos, name])
        );
    }, [data.regionList, data.editInput.value]);

    return (
        <Suggest
            data={parseList()}
            value={data.editInput.value ?? fieldData.initialValue}
            onChange={(e) => onChangeSuggest(e)}
            onInput={(e) => {
                if (!e.target.value) {
                    handleSelectField(null)
                }
                onChange(prev =>({
                    ...prev,
                    editInput: {...prev.editInput, value: e.target.value, error: null}
                }))
            }}
            error={data.editInput.error}
            size={'medium'}
            onDropShow={() => null}
            onDropHide={() => null}
            onClick={() => null}
        />
    );
};

export default RegionSuggest;
